import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { ExternalSharePageProps } from '../src/ExternalSharePage.tsx';

export const ExternalSharePageLoader: LoadableType<ExternalSharePageProps> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ExternalShareRouteComponent" */ '../src/ExternalSharePage.tsx'
			)
		).ExternalSharePage,
});
